import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestCriticalLevel, ADPResourceService as ResourceService } from 'digital-core';

import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorLogService } from "common";
import { SalesActivity, SigningModel } from '../models';
import { ConfigService } from './config.service';
import { HeaderFactoryService } from './header-factory.service';

@Injectable()
export class DocumentLoaderService {

    private httpClient: HttpClient;
    private documentSubject = new Subject<SigningModel>();
    docApiStatusSubscription: Subject<boolean> = new BehaviorSubject<boolean>(true);
    documentState = this.documentSubject.asObservable();
    onespanCategory = "ONESPAN";

    constructor(handler: HttpBackend,
        private configService: ConfigService,
        private errorLogService: ErrorLogService,
        public resourceService: ResourceService,
        private headerService: HeaderFactoryService) {

        this.httpClient = new HttpClient(handler);
    }

    public loadInBackground(salesActivity: SalesActivity): Promise<SigningModel> {

        this.documentSubject.next(null);

        const formData = new FormData();
        formData.append('salesActivity', JSON.stringify(salesActivity));

        return this.httpClient.post<SigningModel>(
            `${this.configService.apiUrl}api/v${this.configService.apiVersion
            }/Signature/signingUrl`,
            formData,
            this.headerService.getAuthorizationHeaderOptions(null,
                RequestCriticalLevel.Critical,
                formData
            )
        ).pipe(tap(res => {
            this.documentSubject.next(res);
            this.docApiStatusSubscription.next(true);
        })).pipe(catchError((error: HttpErrorResponse) => {
            const apiResponse = this.extractJSON(error.error);
            let errorMessage :string = this.resourceService.getViewLabel("EligibilityQuestions_Text_FailDescription");
            if(!!apiResponse && !!apiResponse.message){
                const errorList = this.resourceService.getComplexList("Global_ErrorMessages");
                let errorMsg = errorList.find(item => item.Code === apiResponse.messageKey && item.Category === this.onespanCategory);
                errorMessage = errorMsg ? errorMsg.Value : apiResponse.message;
            }
            this.errorLogService.showInfo(errorMessage, true);
            this.documentSubject.next(null);
            this.docApiStatusSubscription.next(false);
           return throwError(null);
        })).toPromise();
    }

    public processToSignDocument(salesActivity: SalesActivity) {
        const formData = new FormData();
        formData.append('salesActivity', JSON.stringify(salesActivity));
        return this.httpClient.post<SigningModel>(
            `${this.configService.apiUrl}api/v${this.configService.apiVersion
            }/Signature/signDocument`,
            formData, this.headerService.getAuthorizationHeaderOptions(null,RequestCriticalLevel.Critical,formData)
        );
    }

    public SendEmail(url: string) {

        return this.httpClient.get(
            url,
            this.headerService.getAuthorizationHeaderOptions(null,
                RequestCriticalLevel.Critical
            )
        ).toPromise();
    }

    extractJSON(str: string): APIResponse {
        let firstOpen: number, firstClose: number, candidate: string;
        firstOpen = str.indexOf('{', firstOpen + 1);
        do {
            firstClose = str.lastIndexOf('}');
            if(firstClose <= firstOpen) {
                return undefined;
            }
            do {
                candidate = str.substring(firstOpen, firstClose + 1);
                try {
                    return JSON.parse(candidate);
                }
                catch(e) {
                }
                firstClose = str.substr(0, firstClose).lastIndexOf('}');
            } while(firstClose > firstOpen);
            firstOpen = str.indexOf('{', firstOpen + 1);
        } while(firstOpen != -1);
    }
}
export interface APIResponse {
    messageKey: string;
    message: string;
    code: number;
  }
